import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
  en: {
    translation: {
      // Navbar
      "aboutUs": "About Us",
      "ourServices": "Our Services",
      "driveWithUs": "Drive with us",
      "blog": "Blog",
      "safety": "Safety",
      "contactUs": "Contact us",
      "downloadNow": "Download Now",
      "download": "Download",
      
      // About Us Page
      "heroTitle": "Book Your Ride with",
      "heroSubtitle": "Green, Reliable, and Always On Time",
      "enterPickup": "Enter Pickup Location",
      "enterDrop": "Enter Drop Location",
      "bookRide": "Book Ride",
      "aNewEraBegins": "A New Era Begins",
      "aNewEraDesc": "NURA is reimagining urban mobility through a company-owned fleet of electric vehicles. We deliver zero-emission transportation focused on cleaner cities, inclusive opportunities, and reliable everyday mobility that puts people and the planet first.",
      "ourPromise": "Our Promise",
      "zeroCancellations": "zero cancellations",
      "fiveMinutePickups": "5-minute pickups",
      "electricMobility": "100% electric mobility",
      "guaranteedRides": "Guaranteed rides with",
      "quickPickups": "Quick",
      "forEverydayTravel": "for everyday city travel",
      "builtForCleaner": ", built for a cleaner planet",
      "zeroEmissions": "Zero Emissions",
      "poweredByNura": "Powered By NURA",
      
      // Our Services Page
      "yourEverydayRide": "Your everyday city ride, now electric.",
      "chooseYourRide": "Choose Your Ride",
      "rideNow": "Ride Now",
      "rideNowDesc": "Need a quick ride? Book & Ride Now",
      "bookYourRide": "Book your ride now",
      "autoMate": "Auto-mate",
      "autoMateDesc": "Enjoy the feeling of owning an Auto with monthly subscription plans",
      "setupDailyRide": "Set up your daily ride",
      "juniorRides": "Junior Rides",
      "juniorRidesDesc": "School rides made safe & stress free",
      "bookChildRide": "Book your child's safe ride",
      "hopAndGo": "Hop & Go",
      "hopAndGoDesc": "Simply hop & go wherever you need.",
      "findRide": "Find a ride near you",
      
      // Highlights
      "zeroCancellationsTitle": "Zero Cancellations",
      "zeroCancellationsDesc": "Guaranteed rides with no last-minute drop-offs.",
      "fiveMinPickups": "5-Minute Pickups",
      "fiveMinPickupsDesc": "Quick and reliable pickups for everyday city travel.",
      "zeroEmissionsTitle": "Zero Emissions",
      "zeroEmissionsDesc": "100% electric rides for cleaner, greener cities.",
      "verifiedPilots": "Verified Pilots",
      "verifiedPilotsDesc": "Trained and verified drivers you can trust.",
      "dashcamEnabled": "Dashcam Enabled",
      "dashcamEnabledDesc": "In-ride dashcams for added passenger safety.",
      
      // Testimonials
      "voicesOfHappyRiders": "Voices of Our",
      "happyRiders": "Happy Riders",
      "realExperiences": "Real experiences from real people",
      
      // Safety Page
      "nuraSafetyStandard": "NURA Safety Standard",
      "safetyBuiltInto": "Safety that's built into every ride – for riders and pilots alike.",
      "safetyForRiders": "Safety for Riders",
      "safetyForPilots": "Safety for Pilots",
      "zeroCancellationsFromUs": "0% cancellations from our side",
      "verifiedTrainedPilots": "Verified and trained pilots",
      "realTimeTracking": "Real-time ride tracking & quick support",
      "fixedEarningModel": "Fixed earning model, no daily pressure",
      "clearTripDetails": "Clear trip details before every ride",
      "onRoadAssistance": "On-road assistance and company support",
      
      // Drive With Us Page
      "driveWithNura": "Drive with Nura",
      "joinCommunity": "Join our community of pilots and be part of the electric mobility revolution. Earn well, work flexibly, and make a positive impact.",
      "applyOnWhatsapp": "Apply Now on WhatsApp",
      "earnMore": "Earn More",
      "earnMoreDesc": "Competitive earnings with weekly payouts and attractive bonus schemes",
      "flexibleHours": "Flexible Hours",
      "flexibleHoursDesc": "Choose your own schedule and work at your convenience",
      "zeroOwnershipCost": "Zero Ownership Cost",
      "zeroOwnershipDesc": "No vehicle? No problem! Drive our electric autos with no upfront investment",
      "growthOpportunities": "Growth Opportunities",
      "growthDesc": "Access to training programs and career advancement opportunities",
      "insuranceCoverage": "Insurance Coverage",
      "insuranceDesc": "Comprehensive insurance coverage for all driver-partners",
      "communitySupport": "Community Support",
      "communityDesc": "Join a supportive community of drivers and get 24/7 assistance",
      "requirements": "Requirements",
      "basicRequirements": "Basic Requirements",
      "documentsNeeded": "Documents Needed",
      
      // Contact Page
      "getInTouch": "Get In Touch",
      "location": "Location",
      "businessHours": "Business Hours",
    }
  },
  ta: {
    translation: {
      // Navbar
      "aboutUs": "எங்களை பற்றி",
      "ourServices": "எங்கள் சேவைகள்",
      "driveWithUs": "எங்களுடன் ஓட்டுங்கள்",
      "blog": "வலைப்பதிவு",
      "safety": "பாதுகாப்பு",
      "contactUs": "தொடர்பு கொள்ளுங்கள்",
      "downloadNow": "இப்போது பதிவிறக்கு",
      "download": "பதிவிறக்கு",
      
      // About Us Page
      "heroTitle": "உங்கள் பயணத்தை பதிவு செய்யுங்கள்",
      "heroSubtitle": "பசுமை, நம்பகமான, எப்போதும் சரியான நேரத்தில்",
      "enterPickup": "பிக்அப் இடத்தை உள்ளிடவும்",
      "enterDrop": "இறங்கும் இடத்தை உள்ளிடவும்",
      "bookRide": "பயணம் பதிவு செய்",
      "aNewEraBegins": "புதிய சகாப்தம் தொடங்குகிறது",
      "aNewEraDesc": "NURA நிறுவனத்திற்கு சொந்தமான மின்சார வாகனங்களின் மூலம் நகர்ப்புற போக்குவரத்தை மறுவரையறை செய்கிறது.",
      "ourPromise": "எங்கள் உறுதிமொழி",
      "zeroCancellations": "ரத்து இல்லை",
      "fiveMinutePickups": "5 நிமிட பிக்அப்",
      "electricMobility": "100% மின்சார போக்குவரத்து",
      "guaranteedRides": "உத்தரவாதமான பயணங்கள்",
      "quickPickups": "விரைவான",
      "forEverydayTravel": "தினசரி நகர பயணத்திற்கு",
      "builtForCleaner": ", சுத்தமான கிரகத்திற்காக",
      "zeroEmissions": "பூஜ்ய உமிழ்வுகள்",
      "poweredByNura": "NURA ஆல் இயக்கப்படுகிறது",
      
      // Our Services Page
      "yourEverydayRide": "உங்கள் தினசரி நகர பயணம், இப்போது மின்சாரம்.",
      "chooseYourRide": "உங்கள் பயணத்தை தேர்வு செய்யுங்கள்",
      "rideNow": "இப்போது பயணம்",
      "rideNowDesc": "விரைவான பயணம் வேண்டுமா? இப்போதே பதிவு செய்யுங்கள்",
      "bookYourRide": "உங்கள் பயணத்தை பதிவு செய்யுங்கள்",
      "autoMate": "ஆட்டோ-மேட்",
      "autoMateDesc": "மாதாந்திர சந்தா திட்டங்களுடன் ஆட்டோ வைத்திருக்கும் உணர்வை அனுபவியுங்கள்",
      "setupDailyRide": "தினசரி பயணத்தை அமைக்கவும்",
      "juniorRides": "ஜூனியர் ரைட்ஸ்",
      "juniorRidesDesc": "பள்ளி பயணங்கள் பாதுகாப்பானவை",
      "bookChildRide": "உங்கள் குழந்தையின் பாதுகாப்பான பயணத்தை பதிவு செய்யுங்கள்",
      "hopAndGo": "ஹாப் & கோ",
      "hopAndGoDesc": "நீங்கள் எங்கு வேண்டுமானாலும் செல்லுங்கள்.",
      "findRide": "அருகில் பயணம் கண்டுபிடிக்கவும்",
      
      // Safety Page
      "nuraSafetyStandard": "NURA பாதுகாப்பு தரநிலை",
      "safetyBuiltInto": "ஒவ்வொரு பயணத்திலும் உள்ளமைக்கப்பட்ட பாதுகாப்பு.",
      "safetyForRiders": "பயணிகளுக்கான பாதுகாப்பு",
      "safetyForPilots": "ஓட்டுநர்களுக்கான பாதுகாப்பு",
      
      // Drive With Us Page
      "driveWithNura": "நுராவுடன் ஓட்டுங்கள்",
      "joinCommunity": "எங்கள் ஓட்டுநர்கள் சமூகத்தில் சேருங்கள்.",
      "applyOnWhatsapp": "வாட்ஸ்அப்பில் விண்ணப்பிக்கவும்",
      "earnMore": "அதிகம் சம்பாதியுங்கள்",
      "flexibleHours": "நெகிழ்வான நேரங்கள்",
      "requirements": "தேவைகள்",
      
      // Contact Page
      "getInTouch": "தொடர்பில் இருங்கள்",
      "location": "இடம்",
      "businessHours": "வணிக நேரங்கள்",
    }
  },
  te: {
    translation: {
      // Navbar
      "aboutUs": "మా గురించి",
      "ourServices": "మా సేవలు",
      "driveWithUs": "మాతో డ్రైవ్ చేయండి",
      "blog": "బ్లాగ్",
      "safety": "భద్రత",
      "contactUs": "మమ్మల్ని సంప్రదించండి",
      "downloadNow": "ఇప్పుడే డౌన్‌లోడ్ చేయండి",
      "download": "డౌన్‌లోడ్",
      
      // About Us Page
      "heroTitle": "మీ రైడ్ బుక్ చేయండి",
      "heroSubtitle": "ఆకుపచ్చ, నమ్మదగిన, ఎల్లప్పుడూ సమయానికి",
      "zeroEmissions": "సున్నా ఉద్గారాలు",
      "poweredByNura": "NURA ద్వారా శక్తి",
      
      // Safety Page
      "nuraSafetyStandard": "NURA భద్రతా ప్రమాణం",
      "safetyForRiders": "రైడర్ల కోసం భద్రత",
      "safetyForPilots": "పైలట్ల కోసం భద్రత",
      
      // Drive With Us
      "driveWithNura": "నురాతో డ్రైవ్ చేయండి",
      "applyOnWhatsapp": "WhatsAppలో దరఖాస్తు చేయండి",
    }
  },
  kn: {
    translation: {
      // Navbar
      "aboutUs": "ನಮ್ಮ ಬಗ್ಗೆ",
      "ourServices": "ನಮ್ಮ ಸೇವೆಗಳು",
      "driveWithUs": "ನಮ್ಮೊಂದಿಗೆ ಡ್ರೈವ್ ಮಾಡಿ",
      "blog": "ಬ್ಲಾಗ್",
      "safety": "ಸುರಕ್ಷತೆ",
      "contactUs": "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
      "downloadNow": "ಈಗ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
      "download": "ಡೌನ್‌ಲೋಡ್",
      
      // About Us Page
      "heroTitle": "ನಿಮ್ಮ ರೈಡ್ ಬುಕ್ ಮಾಡಿ",
      "heroSubtitle": "ಹಸಿರು, ವಿಶ್ವಾಸಾರ್ಹ, ಯಾವಾಗಲೂ ಸಮಯಕ್ಕೆ",
      "zeroEmissions": "ಶೂನ್ಯ ಹೊರಸೂಸುವಿಕೆ",
      "poweredByNura": "NURA ನಿಂದ ಚಾಲಿತ",
      
      // Safety Page
      "nuraSafetyStandard": "NURA ಸುರಕ್ಷತಾ ಮಾನದಂಡ",
      "safetyForRiders": "ಸವಾರರಿಗಾಗಿ ಸುರಕ್ಷತೆ",
      "safetyForPilots": "ಪೈಲಟ್‌ಗಳಿಗಾಗಿ ಸುರಕ್ಷತೆ",
      
      // Drive With Us
      "driveWithNura": "ನುರಾ ಜೊತೆ ಡ್ರೈವ್ ಮಾಡಿ",
      "applyOnWhatsapp": "WhatsApp ನಲ್ಲಿ ಅರ್ಜಿ ಸಲ್ಲಿಸಿ",
    }
  },
  hi: {
    translation: {
      // Navbar
      "aboutUs": "हमारे बारे में",
      "ourServices": "हमारी सेवाएं",
      "driveWithUs": "हमारे साथ ड्राइव करें",
      "blog": "ब्लॉग",
      "safety": "सुरक्षा",
      "contactUs": "संपर्क करें",
      "downloadNow": "अभी डाउनलोड करें",
      "download": "डाउनलोड",
      
      // About Us Page
      "heroTitle": "अपनी राइड बुक करें",
      "heroSubtitle": "हरित, विश्वसनीय, हमेशा समय पर",
      "enterPickup": "पिकअप स्थान दर्ज करें",
      "enterDrop": "ड्रॉप स्थान दर्ज करें",
      "bookRide": "राइड बुक करें",
      "aNewEraBegins": "एक नए युग की शुरुआत",
      "ourPromise": "हमारा वादा",
      "zeroCancellations": "शून्य रद्दीकरण",
      "fiveMinutePickups": "5 मिनट पिकअप",
      "electricMobility": "100% इलेक्ट्रिक मोबिलिटी",
      "zeroEmissions": "शून्य उत्सर्जन",
      "poweredByNura": "NURA द्वारा संचालित",
      
      // Our Services Page
      "yourEverydayRide": "आपकी रोज़मर्रा की शहर की सवारी, अब इलेक्ट्रिक।",
      "chooseYourRide": "अपनी राइड चुनें",
      "rideNow": "अभी राइड करें",
      "autoMate": "ऑटो-मेट",
      "juniorRides": "जूनियर राइड्स",
      "hopAndGo": "हॉप एंड गो",
      
      // Safety Page
      "nuraSafetyStandard": "NURA सुरक्षा मानक",
      "safetyBuiltInto": "हर राइड में सुरक्षा अंतर्निहित है।",
      "safetyForRiders": "सवारियों के लिए सुरक्षा",
      "safetyForPilots": "पायलटों के लिए सुरक्षा",
      
      // Drive With Us Page
      "driveWithNura": "नुरा के साथ ड्राइव करें",
      "joinCommunity": "हमारे पायलट समुदाय में शामिल हों।",
      "applyOnWhatsapp": "WhatsApp पर आवेदन करें",
      "earnMore": "अधिक कमाएं",
      "flexibleHours": "लचीले घंटे",
      "requirements": "आवश्यकताएं",
      
      // Contact Page
      "getInTouch": "संपर्क में रहें",
      "location": "स्थान",
      "businessHours": "व्यापार के घंटे",
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
